import React from 'react';
import CustomerFormModal from './CustomerFormModal.jsx';

function CreateCustomerModal({ isOpen, onClose, customerNumber }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-xl shadow-lg w-full max-w-4xl max-h-[90vh] overflow-y-auto">
        <h2 className="text-xl font-semibold mb-4">Add new Customer</h2>
        <p>It seems that this customer does not exist in our records.</p>
        <p>
          ¿Do you want to add a new customer with the number{' '}
          <strong>{customerNumber}</strong>?
        </p>

        <CustomerFormModal defaultNumber={customerNumber} onClose={onClose} />

        <div className="mt-6 flex justify-end gap-4">
          <button
            className="px-4 py-2 bg-gray-200 hover:bg-gray-300 rounded"
            onClick={onClose}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}

export default CreateCustomerModal;
